function BotConversationFactory($window) {  
    if(!$window.cf) {
        // If cf is not available you can now provide a
        // mock service, try to load it from somewhere else,
        // redirect the user to a dedicated error page, ...
    }
    return $window.cf;
}

// Define dependencies
BotConversationFactory.$inject = ['$window'];
  
// Register factory
angular.module('survey').factory('cf', BotConversationFactory);  

angular.module('survey').controller('BotConversationController', ["$scope", "$window", 'cf', ($scope, $window, cf) => {

    $scope.showForm = true;
    $scope.botFormFill = (args) => {
        $scope.$emit('botFormFill', args)
    }

    $scope.botFinishConversation = () => {
        $scope.$emit('botFinishConversation');
    }

}]).directive('conversationForm', ['cf', '$timeout', function(cf, $timeout ) {

    const initBotConversation = (scope) => {
        var dispatcher = new cf.EventDispatcher();
        dispatcher.addEventListener(cf.UserInputEvents.FOCUS, function() {
            window.scrollTo(0, document.body.scrollHeight);
        }, false);

        new cf.ConversationalForm({
            formEl: document.getElementById('cf-form'),
            context: document.getElementById("cf-context"),
            eventDispatcher: dispatcher,
            submitCallback: function(){
                window.ConversationalForm.remove();
                scope.finishConversation();
            },
            flowStepCallback: function(dto, success, error){

                let { id, value } = dto.tag;

                if (typeof value === 'string') {
                    value = value.trim();
                    dto.text = value;
                    dto.tag.setTagValueAndIsValid(dto);
                }

                const questionId = dto.tag.name;
                const questionLabel = dto.tag.domElement && (dto.tag.domElement.getAttribute('question-label'))
                    ? dto.tag.domElement.getAttribute('question-label')
                    : false;

                if ((questionLabel === 'E-Mail' || id == "email-input") && !value.toLowerCase().match(/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/)) {
                    return error('Please enter a valid e-mail address');
                } else if (typeof questionLabel === 'string' && questionLabel.match(/^Name/) && value.split(' ').length > 2) {
                    return error('Please only enter in the name (two words maximum)');
                }

                scope.formFill({ questionId, value });
                return success();
            },
            userImage: '/adhoc/t2t-shoutouts/static/img/megaphone.png',
            robotImage: '/adhoc/t2t-shoutouts/static/img/twitter-dwanye-reed.jpg',
        });
        scope.showForm = false;
    }

    return {
        scope: { 
            formFill: '&', 
            finishConversation: '&' 
        },
        link: (scope) => {
            $timeout(() => initBotConversation(scope))
        }
    }

}]);
